<template>
  <div class="columns is-multiline stadistics" v-if="!loading">
    <div class="column is-12" v-if="hasData() && isShowCharts">
      <h1><span v-if="formattedDateRange">{{ formattedDateRange }}</span></h1>
    </div>
    <div v-else>
      <h1>Debes ingresar un rango de fechas para mostrar los gráficos</h1>
    </div>

    <div class="column is-12" v-if="isShowCharts">
      <div class="box">
        <p class="subtitle">Resumen en columnas apiladas</p>
        <template v-if="hasStackedData">
          <apexchart type="bar" :options="optionsStacked" :series="seriesStacked" height="400"></apexchart>
        </template>
        <div v-else class="empty-state">
          <span class="material-icons empty-state-icon">event_busy</span>
          <p>Sin registros en este rango de fechas</p>
        </div>
      </div>
    </div>

    <div class="column is-12" v-if="isShowCharts">
      <div class="box">
        <p class="subtitle">Productos Normales vs Trade-In</p>
        <template v-if="hasProductTypeData">
          <apexchart type="bar" :options="optionsProductType" :series="seriesProductType" height="400"></apexchart>
        </template>
        <div v-else class="empty-state">
          <span class="material-icons empty-state-icon">swap_horiz</span>
          <p>Sin registros en este rango de fechas</p>
        </div>
      </div>
    </div>

    <div class="column is-12" v-if="isShowCharts">
      <div class="box">
        <p class="subtitle">Tipos de Envío Seleccionados</p>
        <template v-if="hasDeliveryData">
          <apexchart type="bar" :options="optionsDeliveryTypes" :series="seriesDeliveryTypes" height="400"></apexchart>
        </template>
        <div v-else class="empty-state">
          <span class="material-icons empty-state-icon">local_shipping</span>
          <p>Sin registros en este rango de fechas</p>
        </div>
      </div>
    </div>

    <div class="column is-12" v-if="isShowCharts">
      <div class="box">
        <p class="subtitle">Total de Celulares Comprados por Givu</p>
        <template v-if="hasTimelineData">
          <apexchart id="productTimelinesChart" class="chart" :width="'100%'" type="line"
            :options="optionsProductTimelines" :series="seriesProductTimelines"></apexchart>
        </template>
        <div v-else class="empty-state">
          <span class="material-icons empty-state-icon">phone_android</span>
          <p>Sin registros en este rango de fechas</p>
        </div>
      </div>
    </div>

    <div class="column is-12" v-if="seriesNumberOfTouches.length && isShowCharts">
      <div class="box">
        <p class="subtitle">Número de Toques</p>
        <apexchart type="bar" :options="optionsNumberOfTouches" :series="seriesNumberOfTouches" height="350"></apexchart>
      </div>
    </div>

    <div class="column is-12" v-if="seriesAcquisitionChannel.length && isShowCharts">
      <div class="box">
        <p class="subtitle">Canal de Adquisición</p>
        <apexchart type="bar" :options="optionsAcquisitionChannel" :series="seriesAcquisitionChannel" height="350"></apexchart>
      </div>
    </div>

    <div class="column is-12" v-if="seriesOverallStatus.length && isShowCharts">
      <div class="box">
        <p class="subtitle">Estado General</p>
        <apexchart type="bar" :options="optionsOverallStatus" :series="seriesOverallStatus" height="350"></apexchart>
      </div>
    </div>

    <div class="column is-12" v-if="seriesContactMethod.length && isShowCharts">
      <div class="box">
        <p class="subtitle">Método de Contacto</p>
        <apexchart type="bar" :options="optionsContactMethod" :series="seriesContactMethod" height="350"></apexchart>
      </div>
    </div>

    <div class="column is-12" v-if="seriesIsFirstSale.length && isShowCharts">
      <div class="box">
        <p class="subtitle">¿Es primera venta?</p>
        <apexchart
          type="bar"
          :options="optionsIsFirstSale"
          :series="seriesIsFirstSale"
          height="350"
        />
      </div>
    </div>

    <div class="column is-12" v-if="seriesIsDuplicateProduct.length && isShowCharts">
      <div class="box">
        <p class="subtitle">¿Es producto duplicado?</p>
        <apexchart
          type="bar"
          :options="optionsIsDuplicateProduct"
          :series="seriesIsDuplicateProduct"
          height="350"
        />
      </div>
    </div>

    <div class="column is-12" v-if="seriesCustomerRejectedPrice.length && isShowCharts">
      <div class="box">
        <p class="subtitle">¿El cliente rechazó por precio?</p>
        <apexchart
          type="bar"
          :options="optionsCustomerRejectedPrice"
          :series="seriesCustomerRejectedPrice"
          height="350"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <loading-component />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'charts',
  data () {
    return {
      loading: false,
      startDate: null,
      endDate: null,
      isShowCharts: true,
      optionsStacked: {
        chart: { type: 'bar', stacked: true, height: 400, toolbar: { show: true } },
        plotOptions: { bar: { horizontal: false } },
        xaxis: { categories: [] },
        legend: { position: 'top' },
        colors: ['#9A2EFE', '#DA6255', '#00FF96']
      },
      seriesStacked: [],
      optionsDeliveryTypes: {
        chart: { type: 'bar', stacked: true, height: 400, toolbar: { show: true } },
        plotOptions: { bar: { horizontal: false } },
        xaxis: { categories: [] },
        legend: { position: 'top' },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560']
      },
      seriesDeliveryTypes: [],
      optionsProductTimelines: {
        chart: {
          id: 'productTimelinesChart',
          width: '75%',
          events: {
            click: (event, chartContext, opts) => {
              const dataIndex = opts.dataPointIndex
              const label = this.optionsProductTimelines.xaxis.categories[dataIndex]
              if (label) {
                const types = {
                  month: /^\d{4}\s-\s\d{2}$/,
                  day: /^\d{4}-\d{2}-\d{2}$/,
                  time: /^\d{2}:\d{2}$/
                }

                for (let type in types) {
                  if (types[type].test(label)) {
                    let startDate, endDate

                    if (type === 'day') {
                      startDate = label
                      endDate = label
                    } else if (type === 'month') {
                      const [year, month] = label.split(' - ')
                      startDate = `${year}-${month}-01`
                      const lastDay = new Date(year, month, 0).getDate()
                      endDate = `${year}-${month}-${lastDay}`
                    } else if (type === 'time') {
                      startDate = label
                      endDate = label
                      return
                    }

                    const url = `/productos?page=1&filter=3&search=&sortKey=product.updatedAt&sortOrder=desc&username=&startDate=${startDate}&endDate=${endDate}`
                    window.location.href = url
                    break
                  }
                }
              } else {
                console.log('Label no encontrado para el índice:', dataIndex)
              }
            }
          }
        },
        xaxis: { categories: [] },
        colors: ['#00FF96']
      },
      seriesProductTimelines: [{}],

      seriesProductType: [],
      optionsProductType: {
        chart: { type: 'bar', stacked: true, height: 400, toolbar: { show: true } },
        plotOptions: { bar: { horizontal: false } },
        xaxis: { categories: [] },
        legend: { position: 'top' },
        colors: ['#00C7BE', '#FF6B6B']
      },

      seriesNumberOfTouches: [],
      optionsNumberOfTouches: { chart: { type: 'bar', height: 350 }, xaxis: { categories: [] }, colors: ['#9A2EFE'] },

      seriesAcquisitionChannel: [],
      optionsAcquisitionChannel: { chart: { type: 'bar', height: 350 }, xaxis: { categories: [] }, colors: ['#DA6255'] },

      seriesOverallStatus: [],
      optionsOverallStatus: { chart: { type: 'bar', height: 350 }, xaxis: { categories: [] }, colors: ['#00FF96'] },

      seriesContactMethod: [],
      optionsContactMethod: { chart: { type: 'bar', height: 350 }, xaxis: { categories: [] }, colors: ['#FFA500'] },

      seriesIsFirstSale: [],
      optionsIsFirstSale: {
        chart: { type: 'bar', height: 350 },
        xaxis: { categories: [] },
        colors: ['#4CAF50']
      },

      seriesIsDuplicateProduct: [],
      optionsIsDuplicateProduct: {
        chart: { type: 'bar', height: 350 },
        xaxis: { categories: [] },
        colors: ['#FF9800']
      },

      seriesCustomerRejectedPrice: [],
      optionsCustomerRejectedPrice: {
        chart: { type: 'bar', height: 350 },
        xaxis: { categories: [] },
        colors: ['#F44336']
      }

    }
  },
  props: {
    dateSegmentationGraph: { type: Object, default: () => ({}) },
    shouldShowCharts: { type: Boolean, default: false }
  },
  computed: {
    formattedDateRange () {
      if (this.startDate && this.endDate) {
        return `Rango de fecha: ${moment(this.startDate).format('DD-MM-YYYY')} / ${moment(this.endDate).format('DD-MM-YYYY')}`
      }
      return null
    },
    hasStackedData () {
      return this.seriesStacked.some(s => s.data && s.data.some(v => v > 0))
    },
    hasTimelineData () {
      return this.seriesProductTimelines.some(s => s.data && s.data.some(v => v > 0))
    },
    hasDeliveryData () {
      return this.seriesDeliveryTypes.some(s => s.data && s.data.some(v => v > 0))
    },
    hasProductTypeData () {
      return this.seriesProductType.some(s => s.data && s.data.some(v => v > 0))
    }
  },
  methods: {
    ...mapActions(['getDashboardChartProductsSegmentation', 'getDashboardChartProducts']),

    getInfo (dateObj = null, useSegmentation = false) {
      this.loading = true
      const fn = useSegmentation ? this.getDashboardChartProductsSegmentation : this.getDashboardChartProducts

      const payloadPromise = useSegmentation && dateObj ? fn(dateObj) : fn()

      payloadPromise
        .then(result => {
          const productData = result.productDataChart || result.payload?.productDataChart || []
          const timelinesData = result.countProductTimelinesWithCloseDate || result.payload?.countProductTimelinesWithCloseDate || []
          const usersData = result.usersDataChart || result.payload?.usersDataChart || []
          const deliveryData = result.deliveryTypesChart || result.payload?.deliveryTypesChart || []

          const monthsSet = new Set()

          if (useSegmentation) {
            productData.forEach(d => {
              if (d.unit) {
                monthsSet.add(d.unit)
              }
            })

            timelinesData.forEach(d => {
              if (d.unit) {
                monthsSet.add(d.unit)
              }
            })

            usersData.forEach(d => {
              if (d.unit) {
                monthsSet.add(d.unit)
              }
            })

            deliveryData.forEach(d => {
              if (d.unit) {
                monthsSet.add(d.unit)
              }
            })
          } else {
            productData.forEach(d => { if (d.unit) monthsSet.add(d.unit) })
            timelinesData.forEach(d => { if (d.unit) monthsSet.add(d.unit) })
            usersData.forEach(d => { if (d.unit) monthsSet.add(d.unit) })
          }

          const categories = Array.from(monthsSet).sort()

          const mapData = (data) => categories.map(cat => {
            const items = data.filter(d => d.unit === cat)
            return items.reduce((sum, item) => sum + Number(item.total), 0)
          })

          this.seriesStacked = [
            { name: 'Usuarios', data: mapData(usersData) },
            { name: 'Productos', data: mapData(productData) },
            { name: 'Productos comprados', data: mapData(timelinesData) }
          ]

          if (useSegmentation) {
            const mapDeliveryData = (key) => categories.map(cat => {
              const items = deliveryData.filter(d => d.unit === cat)
              return items.reduce((sum, item) => sum + Number(item[key]), 0)
            })

            this.seriesDeliveryTypes = [
              { name: 'Entregar Hoy', data: mapDeliveryData('count_pickup_now') },
              { name: 'Acordar Cita', data: mapDeliveryData('count_appointment') },
              { name: 'Recolección a Domicilio', data: mapDeliveryData('count_home_pickup') },
              { name: 'Envío a domicilio', data: mapDeliveryData('count_dhl') }
            ]
            this.optionsDeliveryTypes = { ...this.optionsDeliveryTypes, xaxis: { categories } }
          } else {
            const totalDelivery = result.delivery_types_total || result.payload?.delivery_types_total || null
            if (totalDelivery) {
              this.seriesDeliveryTypes = [
                { name: 'Entregar Hoy', data: [Number(totalDelivery.count_pickup_now || 0)] },
                { name: 'Acordar Cita', data: [Number(totalDelivery.count_appointment || 0)] },
                { name: 'Recolección a Domicilio', data: [Number(totalDelivery.count_home_pickup || 0)] },
                { name: 'Envío a domicilio', data: [Number(totalDelivery.count_dhl || 0)] }
              ]
              this.optionsDeliveryTypes = { ...this.optionsDeliveryTypes, xaxis: { categories: ['Total Histórico'] } }
            } else {
              this.seriesDeliveryTypes = []
            }
          }

          this.optionsStacked = { ...this.optionsStacked, xaxis: { categories } }

          let timelineLabels

          if (useSegmentation) {
            timelineLabels = timelinesData.map(e => {
              if (!e.unit) return 'Sin fecha'

              if (e.unit.includes('-')) {
                const [year, month, day] = e.unit.split('-')
                return `${year} - ${month} - ${day}`
              } else if (e.unit.includes(':')) {
                return e.unit
              } else {
                return 'Sin fecha'
              }
            })
          } else {
            timelineLabels = timelinesData.map(e => e.month && e.year ? `${e.year} - ${e.month}` : 'Sin fecha')
          }

          const timelineValues = timelinesData.map(e => Number(e.total))
          this.seriesProductTimelines = [{ data: timelineValues, name: 'Líneas de productos' }]
          this.optionsProductTimelines = { ...this.optionsProductTimelines, xaxis: { categories: timelineLabels } }

          // 🔹 Trade-In vs Normal
          const productTypeData = result.productTypeChart || result.payload?.productTypeChart || []
          if (productTypeData.length > 0) {
            const ptCategories = productTypeData.map(d => d.unit)
            this.seriesProductType = [
              { name: 'Normal', data: productTypeData.map(d => Number(d.normal_count || 0)) },
              { name: 'Trade-In', data: productTypeData.map(d => Number(d.trade_in_count || 0)) }
            ]
            this.optionsProductType = { ...this.optionsProductType, xaxis: { categories: ptCategories } }
          } else {
            this.seriesProductType = []
          }

          this.loading = false
        })
        .catch(err => {
          console.error('Error al obtener datos del dashboard:', err)
          this.loading = false
        })
    },

    hasSeriesData (data) {
      return Array.isArray(data) && data.length > 0
    },
    hasData () {
      return this.seriesProductTimelines?.[0]?.data?.length > 0
    },

    async getChartsSeparate () {
      this.loading = true
      try {
        const result = await this.getDashboardChartProducts()

        const buildChart = (data) => {
          if (!data || !Array.isArray(data) || data.length === 0) return { series: [], categories: [] }
          const categories = data.map(d => d.label || 'Sin etiqueta')
          const values = data.map(d => Number(d.value) || 0)
          return { series: [{ name: 'Cantidad', data: values }], categories }
        }

        const touchesChart = buildChart(result.number_of_touches)
        const channelChart = buildChart(result.acquisition_channel)
        const statusChart = buildChart(result.overall_status)
        const contactChart = buildChart(result.contact_method)

        const firstSaleChart = buildChart(result.is_first_sale)
        const duplicateProductChart = buildChart(result.is_duplicate_product)
        const rejectedPriceChart = buildChart(result.customer_rejected_price)

        this.seriesIsFirstSale = firstSaleChart.series
        this.optionsIsFirstSale = {
          ...this.optionsIsFirstSale,
          xaxis: { categories: firstSaleChart.categories }
        }

        this.seriesIsDuplicateProduct = duplicateProductChart.series
        this.optionsIsDuplicateProduct = {
          ...this.optionsIsDuplicateProduct,
          xaxis: { categories: duplicateProductChart.categories }
        }

        this.seriesCustomerRejectedPrice = rejectedPriceChart.series
        this.optionsCustomerRejectedPrice = {
          ...this.optionsCustomerRejectedPrice,
          xaxis: { categories: rejectedPriceChart.categories }
        }

        this.seriesNumberOfTouches = touchesChart.series
        this.optionsNumberOfTouches = { ...this.optionsNumberOfTouches, xaxis: { categories: touchesChart.categories } }

        this.seriesAcquisitionChannel = channelChart.series
        this.optionsAcquisitionChannel = { ...this.optionsAcquisitionChannel, xaxis: { categories: channelChart.categories } }

        this.seriesOverallStatus = statusChart.series
        this.optionsOverallStatus = { ...this.optionsOverallStatus, xaxis: { categories: statusChart.categories } }

        this.seriesContactMethod = contactChart.series
        this.optionsContactMethod = { ...this.optionsContactMethod, xaxis: { categories: contactChart.categories } }

        this.loading = false
      } catch (err) {
        console.error('Error al obtener charts separados:', err)
        this.loading = false
      }
    }
  },
  watch: {
    dateSegmentationGraph (newData) {
      if (newData && Object.keys(newData).length > 0) {
        const dateObj = {
          start: moment(newData?.start).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end: moment(newData?.end).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        this.startDate = newData?.start
        this.endDate = newData?.end
        this.getInfo(dateObj, true)
      } else {
        this.startDate = null
        this.endDate = null
        this.getInfo()
      }
    }
  },
  mounted () {
    const dateObj = {
      start: moment(this.dateSegmentationGraph.start).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end: moment(this.dateSegmentationGraph.end).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    }
    this.startDate = this.dateSegmentationGraph.start
    this.endDate = this.dateSegmentationGraph.end
    this.getInfo(dateObj, true)
    this.getChartsSeparate()
  },
  components: {
    LoadingComponent: () => import('@/components/ui/Loading')
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  color: #aaa;
}
.empty-state-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.4;
}
.empty-state p {
  font-size: 15px;
  margin: 0;
}
</style>
